import http, {configForm, configJson} from "./config/http-configs";

export const accountCreate = (account) => {
    const url = "/manage/account/create"
    return http.post(url, account, configJson)
}

export const accountLogin = (name, password) => {
    const url = `/manage/account/login/name?name=${name}&password=${password}`
    return http.post(url, null, configForm)
}

export const accountUpdate = (account) => {
    const url = "/manage/account/update"
    return http.post(url, account, configJson)
}

// 校验当前登录账号（管理/员工）密码，替代 cookie 缓存明文比对（SSO 会话无缓存、改密后缓存不刷新）
export const checkPassword = (password) => {
    const url = "/manage/account/check/password"
    return http.post(url, {password}, configJson)
}

export const accountDelete = (accountId) => {
    const url = `/manage/account/delete/${accountId}`
    return http.get(url)
}

export const getAllAccount = () => {
    const url = "/manage/account/all"
    return http.get(url)
}

export const getVerCode2 = (phoneNo, type) => {
    const url = `/sms/send/verify/?tel=${phoneNo}&type=${type}`
    return http.post(url, null, configForm)
}

export const checkVerCode = (phoneNo, code) => {
    const url = `/sms/verify?tel=${phoneNo}&code=${code}`
    return http.post(url, null, configForm)
}


export const getAccountPermissionSetting = () => {
    const url = "/manage/auth/list/all"
    return http.get(url)
}